
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import FadeInSection from '../ui/FadeInSection';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/components/i18n/language-provider';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden bg-[#f6ecf1]">
      <div className="absolute inset-0 keystle-dot-pattern -z-10 opacity-50"></div>
      <div className="absolute inset-0 bg-gradient-radial from-transparent to-[#f6ecf1] -z-10"></div>
      
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <FadeInSection>
            <div className="inline-block mb-5">
              <div className="rounded-full px-3 py-1 text-sm bg-brand-pink/10 text-brand-pink font-medium mb-1">
                {t('hero.tagline')}
              </div>
            </div>
          </FadeInSection>
          
          <FadeInSection delay={100}>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
              Embrace a passwordless digital experience
            </h1>
          </FadeInSection>
          
          <FadeInSection delay={200}>
            <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto">
              {t('hero.description')}
            </p>
          </FadeInSection>
          
          <FadeInSection delay={300}>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg" 
                className="px-6 font-medium text-base bg-white text-black hover:bg-[#b688a4] hover:text-white transition-colors border border-[#b688a4]"
                onClick={() => navigate('/products')}
              >
                {t('hero.exploreProducts')}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </FadeInSection>
        </div>
      </div>
      
      {/* Abstract graphic effect */}
      <div className="absolute -bottom-10 -left-10 h-64 w-64 rounded-full bg-brand-pink/10 filter blur-3xl opacity-70 -z-10"></div>
      <div className="absolute -top-10 -right-10 h-64 w-64 rounded-full bg-brand-purple/10 filter blur-3xl opacity-70 -z-10"></div>
    </section>
  );
};

export default HeroSection;
